export const displaySize = '30px';
